import {StoreConstants} from '../constants/store.constants';
import type {AnyPayloadAction, DataState} from '../models/store.models';
import {storeState} from '../models/store.models';

export function DataReducer(state: DataState = storeState.Data, action: AnyPayloadAction): DataState {
  if (action.group !== StoreConstants.StoreGroups.Data) return state;

  switch (action.type) {
    case StoreConstants.Data.COUNTRIES$:
      return {
        ...state,
        countries$: action.countries$
      };

    case StoreConstants.Data.USER_POLICY$:
      return {
        ...state,
        userPolicy$: action.userPolicy$
      };

    case StoreConstants.Data.PRIVACY_POLICY$:
      return {
        ...state,
        privacyPolicy$: action.privacyPolicy$
      };

    case StoreConstants.Data.TERMS_OF_USE$:
      return {
        ...state,
        termsOfUse$: action.termsOfUse$
      };

    case StoreConstants.Data.USER_SETTINGS$:
      return {
        ...state,
        userSettings$: action.userSettings$
      };

    case StoreConstants.Data.TEAM$:
      return {
        ...state,
        team$: action.team$
      };

    case StoreConstants.Data.ASSETS$:
      return {
        ...state,
        assets$: action.assets$
      };

    case StoreConstants.Data.ASSETS:
      return {
        ...state,
        assets: action.assets
      };

    case StoreConstants.Data.ASSET_FEEDS$:
      return {
        ...state,
        assetFeeds$: action.assetFeeds$
      };

    case StoreConstants.Data.ASSET_FEEDS:
      return {
        ...state,
        assetFeeds: action.assetFeeds
      };

    case StoreConstants.Data.ASSET_AUTHORS$:
      return {
        ...state,
        assetAuthors$: action.assetAuthors$
      };

    case StoreConstants.Data.ASSET_AUTHORS:
      return {
        ...state,
        assetAuthors: action.assetAuthors
      };

    default:
      return state;
  }
}
